import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { AppLanguageService } from './app-language.service';
import { DEFAULT_LANGUAGE, isAppLanguage, readStoredLanguage } from './language-storage';

/** Load i18n JSON before first render so `instant()` and pipes resolve keys. */
export function initializeTranslations(): Promise<unknown> {
  const translate = inject(TranslateService);
  const appLanguage = inject(AppLanguageService);
  const configured = translate.getCurrentLang() || translate.getFallbackLang() || DEFAULT_LANGUAGE;
  const lang = readStoredLanguage() ?? (isAppLanguage(configured) ? configured : DEFAULT_LANGUAGE);

  return firstValueFrom(translate.use(lang)).then(() => {
    appLanguage.currentLanguage.set(lang);
  });
}
